<template>
    <div>
        <div class="SubscribeSec">
            <div class="container">
                <div class="row">
                    <div class="SubscribeMain">
                        <div class="col-md-12">
                            <div class="SubscribeText wow slideInLeft animated" data-wow-duration="4s" data-wow-delay="1.5s">
                                <i class="fa fa-paper-plane-o"></i>
                                <div class="SubscribeTextBlock">
                                    <h3>Join Our Newsletter Now</h3>
                                    <p>Wants To Get Latest Update</p>
                                </div>
                            </div>
                            <form>
                                <div class="form-group wow slideInRight animated" data-wow-duration="4s" data-wow-delay="2s">
                                    <input type="text" class="form-control" placeholder="Enter Your Email" v-model="email" :class="errorClass">
                                    <input type="button" class="btn btn-default" value="Subscribe" @click="subscribeNewsletter">
                                </div>
                                <span v-if="errorState" style="color:red;">{{ errorMsg }}</span>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data(){
        return {
            email: '',
            errorClass: '',
            errorState: false,
            errroMsg:'',
        }
    },
    methods:{
        subscribeNewsletter(){
            let that = this;
            let data = {
                'email' : this.email
            }
            axios.post(this.url+'/newsletter/subscribe',data).then(function(response){
                that.errorMsg = '';
                that.errorState = false;
                that.errorClass = '';
                that.email = '';
                Vue.$toast.open({
                    message: response.data.message,
                    type: "success",
                    duration: 5000,
                    dismissible: true
                })
            }).catch(function(error){
                that.errorMsg = error.response.data.errors.email ? error.response.data.errors.email[0] : error.response.data.message;
                that.errorState = true;
                that.errorClass = 'input_req';
            }).finally(function(data){
                console.log('data',data);
            })
        }
    },
    computed:{
        url:function(){
            return process.env.MIX_API_URL;
        }
    }
}
</script>
<style scoped>
    .input_req{
        border: 1px solid red;
    }
</style>